module.exports = __webpack_public_path__ + "img/YR25-0500-2-btn.3099568d.png";